import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper
 *  - Wrapper for GroupC
 */
export function Wrapper(props) {
  const style = {backgroundColor: props.color};

  return (
    <div className={props.className} style={style}>
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * Theme color for the group
   */
  color: PropTypes.string,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   *  Child components to render in Step
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Wrapper.defaultProps = {
  className: '',
  tabIndex: 0,
};
